export const REDEEM_REFERRAL_START = 'REDEEM_REFERRAL_START';
export const REDEEM_REFERRAL_SUCCESS = 'REDEEM_REFERRAL_SUCCESS';
export const REDEEM_REFERRAL_ERROR = 'REDEEM_REFERRAL_ERROR';
export const CLEAR_REDEEM_REFERRAL = 'CLEAR_REDEEM_REFERRAL'